<template>
    <div class="shop-container">
        <div v-for="item in items">
            <a :href="$t(item.link)" target="_blank">
                <img :src="image(item)">
                <span v-if="item.info" class="bold" v-html="$t(item.info)"></span>
                <span v-html="$t(item.title)"></span>
            </a>
        </div>
    </div>
</template>

<script>
let images = require.context("../../assets/img/shop", false, /\.png$/);

export default {
  name: "shop",
  methods: {
    image: function(item) {
      return images("./" + item.img + ".png");
    }
  },
  data: function() {
    return {
      items: [
        {
          img: "cd",
          title: "shop.cd",
          link: "shop.cd-link",
          info: ""
        },
        {
          img: "double-cd",
          title: "shop.double-cd",
          link: "shop.double-cd-link",
          info: ""
        },
        {
          img: "dvd",
          title: "shop.dvd",
          link: "shop.dvd-link",
          info: ""
        },
        {
          img: "programmheft",
          title: "shop.program",
          link: "shop.program-link",
          info: ""
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/var";

.shop-container {
  display: flex;
  flex-wrap: wrap;

  > div {
    display: inline-block;
    width: 46%;
    margin: 2%;
    text-align: center;
    cursor: pointer;

    a {
      color: inherit;
      text-decoration: none;

      img {
        margin-bottom: 10px;

        @include media-phone {
          width: 75%;
        }
      }
    }

    span {
      width: 100%;
      text-align: center;
      font-size: 20px;

      &.bold {
        font-weight: 700;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainSegments/Shop.vue